import { render, staticRenderFns } from "./EditLimitation.vue?vue&type=template&id=d835498c&scoped=true"
import script from "./EditLimitation.vue?vue&type=script&lang=js"
export * from "./EditLimitation.vue?vue&type=script&lang=js"
import style0 from "./EditLimitation.vue?vue&type=style&index=0&id=d835498c&prod&lang=scss"
import style1 from "./EditLimitation.vue?vue&type=style&index=1&id=d835498c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d835498c",
  null
  
)

export default component.exports